import { UserUtils } from '~/utils/UserUtils';
import { DraftJobPostAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';
import { ICreateDraftJobResult } from '../types';

export const createDraftJobPost = async (): Promise<ICreateDraftJobResult> => {
  const response = await PermanentJobsApi.createDraftJobPost({
    isOfficeSelected: UserUtils.isParentOffice() ? false : true,
  });

  return DraftJobPostAdapters.toCreateDraftJobPostResult(response);
};
